import { Typography, Button } from "@material-ui/core";
import "../../styles/Globales.scss";
import "../../styles/SolicitarPortabilidad.scss";
import React from "react";
import SwitchComponent from "./SwitchComponent";
import { Add } from "@material-ui/icons";
import { observer } from "mobx-react";
import appStore from "../../stores/AppStore";

const component = observer(
  class SeleccionFamiliaComponent extends React.Component {
    onChangeTodos = (selected) => {
      if (selected) {
        if (this.props.todosEncendido) {
          const producto = appStore.solicitarNuevaPortalidadStore.buscarProductoPorNemo(this.props.tipoFamilia.value);
          let nombreProducto = this.props.tipoFamilia.nombre;
          if (producto) {
            nombreProducto = producto.nombre;
          }
          this.props.todosEncendido({ codProducto: this.props.tipoFamilia.value, nombreProducto: nombreProducto });
        }
      } else {
        if (this.props.onTodosApagado) {
          this.props.onTodosApagado(this.props.tipoFamilia.value);
        }
      }
    };

    onAgregarIndividual = () => {
      if (this.props.onAgregarIndividual) {
        this.props.onAgregarIndividual(this.props.tipoFamilia.value);
      }
    };

    render() {
      let btnAgregar;
      if (!this.props.todosSeleccionado) {
        btnAgregar = (
          <Button className="btnRipley alinearIzq" onClick={this.onAgregarIndividual}>
            <Add />
            {this.props.etiquetaAgregar}
          </Button>
        );
      }
      return (
        <div className="contenedorFamilia">
          <div className="contenedorSwitch">
            <Typography className="tituloStepSolicitudAcordeon">{this.props.tipoFamilia.nombre}</Typography>
            <div className="Switch">
              <SwitchComponent etiqueta={this.props.etiquetaSwitch} onChange={this.onChangeTodos} checked={this.props.todosSeleccionado} />
            </div>
            {btnAgregar}
          </div>
        </div>
      );
    }
  }
);
const SeleccionFamiliaComponent = component;
export default SeleccionFamiliaComponent;
